export const AUTHENTICATE = "AUTHENTICATE";
export const LOGOUT = "LOGOUT";
export const APPENDFILTERS = "APPENDFILTERS";

